<template>
  <wizard-form v-bind="ouiaProps" :hidden="hidden" :title="$t('Configurazione')">
    <pf-title h="2" class="pf-v6-u-mt-lg">{{ $t('Configurazione applicativa')}}</pf-title>

    <wizard-question v-if="wizard.askDb" :title="$t('Versione MySQL')">
      <template #description>{{ $t('Indicaci quale versione di MySQL vuoi attivare.') }}</template>
      <wizard-question-options name="mysql" v-model="wizard.db" :options="wizard.filteredOpzioniDb" :null-label="$t('Non necessario')"/>
    </wizard-question>

    <wizard-question v-if="wizard.askPhp" :title="$t('Versione PHP')">
      <template #description>{{ $t('Indicaci quale versione di PHP vuoi attivare.') }}</template>
      <wizard-question-options name="php" v-model="wizard.php" :options="wizard.filteredOpzioniPhp" :null-label="$t('Non necessario')"/>
    </wizard-question>

    <wizard-question v-if="wizard.askTecnologie" :title="$t('Tecnologie e applicativi')">
      <template #description>{{ $t('Indicaci quali di queste tecnologie verranno utilizzate.') }}</template>
      <wizard-question-tecnologie v-model="wizard.tecnologie" />
    </wizard-question>
  </wizard-form>
</template>

<style scoped>
.required-hidden{
  position: relative;
  width: 1px;
  height:1px;
  left: 25px;
}
</style>

<script lang="ts" setup>
import { useOUIAProps, type OUIAProps } from '@common/ouia';
import { useWizardStep } from '../composition';

import WizardQuestion from '../questions/wizard-question.vue';
import WizardQuestionTecnologie from '../questions/wizard-question-tecnologie.vue';
import wizardQuestionOptions from '../questions/wizard-question-options.vue';
import WizardForm from '../wizard-form.vue';

defineOptions({
  name: 'WizardStepConfigurazione',
});

const props = defineProps<OUIAProps>();
const ouiaProps = useOUIAProps(props);

const { wizard, hidden, isEnabled } = useWizardStep({
  isEnabled: wizard => wizard.askConfigurazione,
});

defineExpose({
  isEnabled,
});
</script>
